import 'babel-polyfill';
import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import Home from './pages/Home';
import BaseApp from './lib/template/app';
import './index.css';
import store from './store';
import Ponits from './points';

class App extends BaseApp {
    constructor () {
        super();

        // 预加载配置（无需预加载可去除该配置）
        this.preLoadConfig = {
            // 预加载图片列表
            imgList: [
                'loading.a56fa8a5.gif', 'mainbgys.e5e357b7.png', 'dakabiaoti.531cc9d6.png', 'clockbg.f5060402.png', 'baominganniu1.231b4956.png', 'buzhou.f9da4979.png'
            ],
            // 预加载图片路径
            imgPath: `${$SYS.staticUrl}app/douyu-mobile/m-client/493-signin-v2-share/build/images/`,
            // 预加载进度，可做进度条展示
            onLoad: () => {
            }
        };
    }

    init () {
        ReactDOM.render((
            <Provider store={store}>
                <Home />
            </Provider>
        ), document.getElementById('root'));

        Ponits.init_page_zht_actives();
    }
}

new App().launch();
